import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import {
  APPOINTMENT_STATUSES,
  INVOICE_STATUSES,
  type AppointmentStatus,
  type InvoiceStatus,
} from "@emr/shared/constants";

export function AppointmentStatusBadge({ status, className }: { status: AppointmentStatus; className?: string }) {
  const variant: Record<AppointmentStatus, string> = {
    Pending: "bg-cream-200 text-muted border-cream-200",
    Booked: "bg-maroon-600 text-cream-50 border-maroon-600",
    CheckedIn: "bg-green-700 text-cream-50 border-green-700",
    Completed: "bg-green-800 text-cream-50 border-green-800",
    Cancelled: "bg-red-500 text-cream-50 border-red-500",
    NoShow: "bg-cream-100 text-muted border-cream-200",
  };
  return <Badge className={cn("border", variant[status], className)}>{status}</Badge>;
}

export function InvoiceStatusBadge({ status, className }: { status: InvoiceStatus; className?: string }) {
  const variant: Record<InvoiceStatus, string> = {
    Unpaid: "bg-red-500 text-cream-50 border-red-500",
    Partial: "bg-amber-100 text-amber-800 border-amber-300",
    Paid: "bg-green-700 text-cream-50 border-green-700",
  };
  return <Badge className={cn("border", variant[status], className)}>{status}</Badge>;
}

export function AiBadge({ className }: { className?: string }) {
  return <Badge className={cn("bg-maroon-600 text-cream-50 border-maroon-600", className)}>AI</Badge>;
}

export function CloudBadge({ className }: { className?: string }) {
  return <Badge className={cn("bg-green-700 text-cream-50 border-green-700", className)}>Cloud</Badge>;
}

export function SentBadge({ className }: { className?: string }) {
  return <Badge className={cn("bg-green-800 text-cream-50 border-green-800", className)}>Sent</Badge>;
}

export { APPOINTMENT_STATUSES, INVOICE_STATUSES };
